import 'reflect-metadata'
import http from '@caudena/core/http'
import { ctx } from './ctx'
import React, { PropsWithChildren } from 'react'
import { withAuthenticationRequired } from '@caudena/core/Auth/withAuthRequired'
import { useAuth } from '@caudena/core/Auth'
import { useSettings } from './hooks'
import { ThemeProvider } from '@emotion/react'
import { enterprise, InternationalizationProvider } from '@caudena/core/ui-kit'
import App, { RootContent } from '@caudena/core/App'
import { navItems } from './navItems'
import UserDropdown from '@caudena/core/UserDropdown'
import { CryptoConfigurationProvider } from '@caudena/web-platform'
import { getConfig } from '@caudena/core/useConfig'
import { useTranslation } from 'react-i18next'
import {
  CORE_LANG_NAMESPACE,
  UIKIT_LANG_NAMESPACE,
} from '@caudena/core/constants'
import { InternationalizationProviderCore } from '@caudena/core/internationalization'
import { UIKIT_CRYPTO_CONFIGURATION } from './constants/currency'

const wss = getConfig()?.COMPLIANCE_WS
const refreshApiToken = async (token: string, logout: () => void) => {
  http.config({ token })
  await ctx.reconnectWithNewToken(token, logout)
}
const initApiToken = async (
  token: string,
  refreshToken: () => Promise<string>
) => {
  http.config({ token })
  await ctx.init({ wss, token, refreshToken })
}
const AppComponent: React.FC<PropsWithChildren> = withAuthenticationRequired(
  ({ children }) => {
    const { isTokenProvided, logout } = useAuth({
      initApiToken,
      refreshApiToken,
    })

    const { user } = useSettings()
    const { t } = useTranslation()

    return (
      isTokenProvided && (
        <CryptoConfigurationProvider config={UIKIT_CRYPTO_CONFIGURATION as any}>
          <InternationalizationProvider
            t={(key) => t(`${UIKIT_LANG_NAMESPACE}:${key}`)}
          >
            <InternationalizationProviderCore
              t={(key) => t(`${CORE_LANG_NAMESPACE}:${key}`)}
            >
              <ThemeProvider theme={enterprise['light']}>
                <App
                  navItems={navItems}
                  logout={logout}
                  slots={{
                    userDropdown: (
                      <UserDropdown logout={logout} email={user?.email} />
                    ),
                  }}
                >
                  {children}
                </App>
              </ThemeProvider>
            </InternationalizationProviderCore>
          </InternationalizationProvider>
        </CryptoConfigurationProvider>
      )
    )
  }
)
export default function RootApp() {
  return <RootContent AppComponent={AppComponent} />
}
